import { Button } from "antd";
import "../../assets/css/modal-contest.css";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

const locale = require("react-redux-i18n").I18n;
const ModalContest = ({ isOpen = true, onClose = () => {}, contestData }) => {
  const history = useHistory();
  const [isVisible, setIsVisible] = useState(isOpen);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
      setIsClosing(false);
    }
  }, [isOpen]);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsVisible(false);
      onClose();
    }, 300);
  };

  const handleJoinContest = () => {
    // เช็คว่าเข้าร่วมแล้วหรือไม่
    if (contestData?.data?.is_joined) {
      // ถ้าเข้าร่วมแล้ว ไปที่หน้า dashboard ของ contest นั้น
      history.push(
        `/${localStorage.getItem("locale")}/wallet/contest/new-events/${
          contestData?.data?.id
        }`
      );
    } else {
      // ถ้ายังไม่ได้เข้าร่วม ไปที่หน้า contest ทั่วไป
      history.push(
        `/${localStorage.getItem("locale")}/wallet/contest/new-events`
      );
    }
    handleClose();
  };

  if (!isVisible) return null;

  return (
    <div
      className={`modal-contest ${
        isClosing ? "modal-closing" : "modal-opening"
      }`}
    >
      <div className="modal-backdrop" onClick={handleClose} />{" "}
      <div className="modal-container">
        <div className="modal-content-contest">
          <div className="modal-background">
            <img
              src="/assets/images/contest/bg-popup-contest.png"
              alt="Contest background"
              className="modal-bg-image"
            />
          </div>
          <div className="modal-close-button" onClick={handleClose}>
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.05654 7.05727C7.57724 6.53657 8.42146 6.53657 8.94216 7.05727L15.9993 14.1145L23.0565 7.05727C23.5772 6.53657 24.4215 6.53657 24.9422 7.05727C25.4629 7.57797 25.4629 8.42219 24.9422 8.94289L17.885 16.0001L24.9422 23.0573C25.4629 23.578 25.4629 24.4222 24.9422 24.9429C24.4215 25.4636 23.5772 25.4636 23.0565 24.9429L15.9993 17.8857L8.94216 24.9429C8.42146 25.4636 7.57724 25.4636 7.05654 24.9429C6.53584 24.4222 6.53584 23.578 7.05654 23.0573L14.1137 16.0001L7.05654 8.94289C6.53584 8.42219 6.53584 7.57797 7.05654 7.05727Z"
                fill="#F9F9F9"
              />
            </svg>
          </div>
          <div className="modal-body">
            <h2 className="modal-title">{locale.t("popupContest.title")}</h2>
            <p className="modal-subtitle">{locale.t("popupContest.desc")}</p>
            <Button
              className="btn-primary-new-iux"
              style={{
                marginTop: "24px",
                padding: "8px 46px",
                borderRadius: "8px",
                fontSize: "16px",
                lineHeight: "24px",
              }}
              onClick={handleJoinContest}
            >
              {locale.t("popupContest.button")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalContest;
